import { FC, ChangeEvent } from 'react'
import styles from 'styles/components/label.module.scss'
import InputText from 'components/Form/InputText'
import SelectBox, { SelectOption } from 'components/Form/SelectBox'
import InputLabel from 'components/Label/InputLabel'

type Props = {
  required: boolean
  labelName: string
  description: string
  line: number
  type: string
  size: string
  margin?: string
  value: string | number
  value2: string | number
  options: SelectOption[]
  placeholder: string
  errorText?: string | null
  labelSize?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onChange2?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  onInput?: () => void
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void
}

const InputTextAndSelectBoxWithLabel: FC<Props> = (props) => {
  const {
    required,
    labelName,
    description,
    line,
    type,
    size,
    margin,
    value,
    value2,
    options,
    placeholder,
    errorText,
    labelSize,
    onChange,
    onChange2,
    onInput,
    onBlur,
  } = props

  const labelFormContainerStyle = (() => {
    switch (margin) {
      case 'default':
        return styles.labelFormContainer
      case 'narrow':
        return styles.labelFormContainerSub
      case 'min':
        return styles.labelFormContainerMin
      default:
        return styles.labelFormContainer
    }
  })()

  const className = `${labelFormContainerStyle}`

  return (
    <div className={className}>
      <InputLabel
        required={required}
        name={labelName}
        description={description}
        line={line}
        size={labelSize}
      />
      <div>
        <InputText
          required={required}
          type={type}
          size={size}
          value={value}
          placeholder={placeholder}
          rightAligned={true}
          errorText={errorText}
          onChange={(e) => (onChange ? onChange(e) : null)}
          onInput={onInput}
          onBlur={onBlur}
        />
      </div>
      <div className={styles.inputAndUnitTextContainer}>
        <SelectBox
          size={size}
          value={value2}
          options={options}
          onChange={(e) => (onChange2 ? onChange2(e) : null)}
        />
      </div>
    </div>
  )
}

export default InputTextAndSelectBoxWithLabel
